export default "__VITE_ASSET__d8ea4854__"